export function sortLastFirstnameAZ(a: any, b: any) {
  // TODO: update selection the sorting value when the student name display setting is implemented
  const first = (a.original.lastName || '') + a.original.firstName;
  const second = (b.original.lastName || '') + b.original.firstName;
  // TODO: update hardcoded 'en' to Spanish when change to Spanish is implemented
  return first.localeCompare(second, 'en', { numeric: true });
}
